import * as React from 'react';
import { Text, FontIcon, ILabelStyles, mergeStyles, PrimaryButton, ProgressIndicator, Separator, Stack, TextField, Toggle, useTheme, DefaultButton, MessageBar, Icon, CommandButton, CommandBarButton } from '@fluentui/react';
import { IUserContactInfo } from '../../../../Models/Admin/IUserContactInfo';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { validateEmail } from '../../../../Tools/Validation';

interface IUserPropertiesContactInformationProps {
    userContactInfo: IUserContactInfo;
    isLoading: boolean;
    statusMessage?: IStatusMessage;
    changeInfoProperty: (key: string, value: any) => void;
    valid: (state: boolean) => void;
}

export const UserPropertiesContactInformation: React.FunctionComponent<IUserPropertiesContactInformationProps> = (props) => {

    const [validation, setValidation] = React.useState<IUserContactInfo>({ isActive: false, city: "", email: "", emailConfirmed: false, firstName: "", id: "", isContactInformationCompleated: false, isPrivateInformationConsent: false, lastName: "", phoneNumber: "", postalCode:"",street:"" });


    const theme = useTheme();
    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });
    const mainLabelStyle = mergeStyles({ root: { fontSize: theme.fonts.mediumPlus.fontSize, fontWeight: 600 } });
    const labelStyle: ILabelStyles = { root: { color: theme.palette.greenDark } };


    const firmaChanged = (event?: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.changeInfoProperty(id, checked ? true : false);
        }
    }

    const setInfoChange = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.changeInfoProperty(id, newValue);
        }
    }

    const validate = (data: IUserContactInfo): IUserContactInfo =>
    {
        let result = { isActive: false, city: "", email: "", emailConfirmed: false, firstName: "", id: "", isContactInformationCompleated: false, isPrivateInformationConsent: false, lastName: "", phoneNumber: "", postalCode: "", street: "" };
        let valid = true;
        if (!validateEmail(data.email)) {
            result.email = "Zadejte prosím platnou emailovou adresu."
            valid = false;
        }
        if (data.firstName === "") {
            result.firstName = "Zadejte jméno."
            valid = false;
        }
        if (data.lastName === "") {
            result.lastName = "Zadejte příjmení."
            valid = false;
        }
        if (data.street === "") {            
            result.street = "Zadejte ulici."
            valid = false;
        }
        if (data.city === "") {
            result.city = "Zadejte město."
            valid = false;
        }
        if (data.postalCode === "") {
            result.postalCode = "Zadejte PSČ."
            valid = false;
        }
        if (data.phoneNumber === "") {
            result.phoneNumber = "Zadejte tel. číslo"
            valid = false;
        }
        
        props.valid(valid);
        return result;
    }

    React.useEffect(() => {
        setValidation(validate(props.userContactInfo));
    }, [props.userContactInfo])

    //React.useEffect(() => {
    //    setValidation({ city: "", email: "", emailConfirmed: false, firstName: "", id: "", isContactInformationCompleated: false, isPrivateInformationConsent: false, lastName: "", phoneNumber: "", postalCode: "", street: "" });
    //}, [])

    return (

        <Stack>
            <Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: 40 } }}>
                <Stack verticalAlign="start" horizontal grow styles={{ root: { paddingBottom:15 } }} >
                    <TextField styles={{ root: { width: '100%' } }} id="email" description="Při změně emailu se změní i přihlašovací jméno" key="email" label="Email" disabled={props.isLoading} required value={props.userContactInfo.email}
                        onChange={setInfoChange} errorMessage={validation.email} />
                    {props.userContactInfo.id!==""?
                    props.userContactInfo.emailConfirmed ?
                        <Icon iconName="CheckMark" styles={{ root: { marginTop: 5, fontSize: 25, color: 'green' } }} /> :
                        <>
                            <Icon iconName="Cancel" styles={{ root: { marginTop: 8, fontSize: 20, color: 'red', paddingLeft: 10, paddingRight: 10 } }} />
                            <DefaultButton text="Ověřit email" styles={{ root: { minWidth: 120 } }} />
                        </>
                    :null}
                </Stack>

                <TextField id="firstName" key="firstName" label="Jméno" disabled={props.isLoading} required value={props.userContactInfo.firstName}
                    onChange={setInfoChange} errorMessage={validation.firstName} />
                <TextField id="lastName" key="lastName" label="Příjmení" disabled={props.isLoading} required value={props.userContactInfo.lastName} onChange={setInfoChange} errorMessage={validation.lastName} />

                <TextField required id="phoneNumber" key="phoneNumber" label="Telefon" disabled={props.isLoading} value={props.userContactInfo.phoneNumber}
                    onChange={setInfoChange} errorMessage={validation.phoneNumber} />

                <TextField required id="street" key="street" label="Ulice" disabled={props.isLoading} value={props.userContactInfo.street}
                    onChange={setInfoChange} errorMessage={validation.street} />
                <TextField required id="city" key="city" label="Město" disabled={props.isLoading} value={props.userContactInfo.city}
                    onChange={setInfoChange} errorMessage={validation.city} />
                <TextField required id="postalCode" key="postalCode" label="PSČ" disabled={props.isLoading} value={props.userContactInfo.postalCode}
                    onChange={setInfoChange} errorMessage={validation.postalCode} />
            </Stack>
      </Stack>)
}